export function CTA() {
  return (
    <section className="py-24 bg-surface-950">
      <div className="mx-auto max-w-7xl section-padding">
        <div className="relative overflow-hidden rounded-3xl">
          {/* Gradient background */}
          <div className="absolute inset-0 bg-gradient-to-r from-brand-600 via-brand-500 to-accent-cyan" />
          
          {/* Grid pattern overlay */}
          <div className="absolute inset-0 bg-grid opacity-20" />
          
          {/* Content */}
          <div className="relative px-8 py-16 sm:px-16 sm:py-20 text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
              Ready to ship auth in minutes?
            </h2>
            <p className="text-lg text-white/90 max-w-2xl mx-auto mb-8">
              Join thousands of developers who trust JumpstoneAuth to handle authentication. Start free, scale when you're ready.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a 
                href="/signup" 
                className="w-full sm:w-auto btn bg-white text-surface-900 hover:bg-surface-100 text-base px-8 py-3.5 font-semibold"
              >
                Start Building Free
                <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                </svg>
              </a>
              <a 
                href="/docs" 
                className="w-full sm:w-auto btn bg-white/20 text-white hover:bg-white/30 border border-white/30 text-base px-8 py-3.5"
              >
                Read the Docs
              </a>
            </div>

            <p className="mt-6 text-sm text-white/70">
              No credit card required • Free forever for small projects
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

